module.exports = __webpack_public_path__ + "a64a43ff497bbd1cc821222ca645db2e.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/forum-border-ornament.png
// module id = 315
// module chunks = 0